import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    opensDrawer: Boolean 
  }

  updateSelection(event) {
    const paymentMethodInfo = document.getElementById("payment-method-info")
    const selectedMethod = event.target.closest('label').querySelector('p').textContent.trim()
    
    // Masquer toutes les infos par défaut
    paymentMethodInfo.classList.add("hidden")
    paymentMethodInfo.innerHTML = ""
    
    // Afficher des informations spécifiques selon la méthode
    if (selectedMethod === "Espèces") {
      this.showCashInfo(paymentMethodInfo)
    } else if (selectedMethod === "Carte bancaire") {
      this.showCardInfo(paymentMethodInfo)
    } else if (selectedMethod === "Crédit client") {
      this.showCreditInfo(paymentMethodInfo)
    }
  }

  showCashInfo(container) {
    container.innerHTML = `
      <div class="bg-green-50 border border-green-200 rounded-md p-3">
        <div class="flex items-start">
          <svg class="w-5 h-5 text-green-400 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
          </svg>
          <div class="text-sm text-green-700">
            <p class="font-medium">Paiement en espèces</p>
            <p class="mt-1">Le tiroir-caisse s'ouvrira automatiquement après validation du paiement.</p>
          </div>
        </div>
      </div>
    `
    container.classList.remove("hidden")
  }

  showCardInfo(container) {
    container.innerHTML = `
      <div class="bg-blue-50 border border-blue-200 rounded-md p-3">
        <div class="flex items-start">
          <svg class="w-5 h-5 text-blue-400 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
          </svg>
          <div class="text-sm text-blue-700">
            <p class="font-medium">Paiement par carte</p>
            <p class="mt-1">Assurez-vous que la transaction a été validée sur le terminal de paiement avant de confirmer.</p>
          </div>
        </div>
      </div>
    `
    container.classList.remove("hidden")
  }

  showCreditInfo(container) {
    container.innerHTML = `
      <div class="bg-purple-50 border border-purple-200 rounded-md p-3">
        <div class="flex items-start">
          <svg class="w-5 h-5 text-purple-400 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
          </svg>
          <div class="text-sm text-purple-700">
            <p class="font-medium">Paiement par crédit client</p>
            <p class="mt-1">Le montant sera automatiquement débité du portefeuille de crédit du client.</p>
          </div>
        </div>
      </div>
    `
    container.classList.remove("hidden")
  }
}
